// src/components/music/views/CardView.jsx

import { motion } from 'framer-motion';
import { TrackCard } from '../parts/TrackCard';

export const CardView = ({
  filteredMusic,
  currentTrack,
  isPlaying,
  playQueue,
  onPlayPause,
  onPurchase,
  processingPayment,
  groupByAlbum,
  onAddToPlaylist,
  currentUser,
  isPurchased,
  onDownload
}) => {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.5 }}
      className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4 mb-12"
    >
      {filteredMusic.map((track, index) => (
        <TrackCard
          key={track.id}
          track={track}
          index={index}
          isCurrent={currentTrack?.id === track.id}
          isPlaying={isPlaying}
          playQueue={playQueue}
          onPlayPause={onPlayPause}
          onPurchase={onPurchase}
          processingPayment={processingPayment}
          groupByAlbum={groupByAlbum}
          onAddToPlaylist={onAddToPlaylist}
          currentUser={currentUser}
          isPurchased={isPurchased}
          onDownload={onDownload}
        />
      ))}
    </motion.div>
  );
};
